/**
 * Striping Plan check (Backend/Pipeline/routes/striping_plan_routes.py):
 *   POST /rsa/v2/striping-plan/check  what a Striping Plan run would do with each road
 * Carries the signed-in user's idToken, like the run queue (runQueueService.js).
 */
import axios from "axios";
import { processApi } from "../API/api";
import { authHeaders } from "../utils/authHeader";

export const STRIPING_CHECK_URL = `${processApi}/rsa/v2/striping-plan/check`;

export const checkStripingRoads = async (body) => {
  const res = await axios.post(STRIPING_CHECK_URL, body, {
    headers: await authHeaders({ "Content-Type": "application/json" }),
  });
  return res.data;
};

const stripingPlanService = { checkStripingRoads };
export default stripingPlanService;
